import { useLaravelPath } from './useLaravelPath';

/** Return the home page path depending on user's loggin status */
export function useHome() {
  const runtimeConfig = useRuntimeConfig();
  const userStore = useUserStore();
  const localePath = useLocalePath();
  const laravelPath = useLaravelPath();

  // TODO CVO-19899 [Redirect] Remove the laravelRedirect flag once booking flow is released in Veloair

  const homePath = computed(() => {
    const searchPagePath = runtimeConfig.public.laravelRedirect ? laravelPath('/ttw/subscriptions/spa/private-page/redemption') : localePath('/book/search');
    return userStore.isActiveUser ? searchPagePath : localePath('/');
  });

  const isExternalBooking = computed(() => !!runtimeConfig.public.laravelRedirect);

  function goHome() {
    navigateTo(homePath.value as string);
  }

  return {
    homePath,
    isExternalBooking,
    goHome,
  };
}